import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-ways-to-pay',
  templateUrl: './ways-to-pay.component.html',
  styleUrls: ['./ways-to-pay.component.css']
})
export class WaysToPayComponent implements OnInit {

  oneAtATime = true;

  showOnline = false;
  showOnlineDropped = false;

  showByPhone = false;
  showMail = false;
  showPerson = false;

  @ViewChild('accordion1') accordion1: ElementRef;

  constructor() { }

  toggleShowOnline() {
    this.showOnline = !this.showOnline;
    if (this.accordion1.nativeElement.classList.contains('panel-open')) {
      this.showOnlineDropped = true;
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ways-to-pay/ways-to-pay.component.ts